'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002433 from "./presto.-Agent-View$$anon$33.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002434 from "./presto.-Agent-View$$anon$34.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002435 from "./presto.-Agent-View$$anon$35.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002436 from "./presto.-Agent-View$$anon$36.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002437 from "./presto.-Agent-View$$anon$37.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002439 from "./presto.-Agent-View$$anon$39.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002441 from "./presto.-Agent-View$$anon$41.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002443 from "./presto.-Agent-View$$anon$43.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002444 from "./presto.-Agent-View$$anon$44.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$32() {
  this.ayC = null;
  this.ayA = null;
  this.ayB = false;
  this.ayy = null;
  this.ayz = false;
  this.ayD = false;
  this.ayE = false;
  this.ayC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_AgentView$$anon$32 as $c_Lpresto_AgentView$$anon$32 };
$p = $c_Lpresto_AgentView$$anon$32.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$32;
/** @constructor */
function $h_Lpresto_AgentView$$anon$32() {
}
export { $h_Lpresto_AgentView$$anon$32 as $h_Lpresto_AgentView$$anon$32 };
$h_Lpresto_AgentView$$anon$32.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.ayC;
});
$p.t = (function() {
  if ((!this.ayB)) {
    this.ayA = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ErrorMessage", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("LocalShodoSignResponse", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("LocalShodoCertChainResponse", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("LocalPjeOfficeCertChainResponse", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("LocalPjeOfficeSignFileResponse", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("LocalPjeOfficeSignFileBase64Response", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("LocalPjeOfficeSignHashResponse", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("UploadFileResponse", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))))));
    this.ayB = true;
  }
  return this.ayA;
});
$p.ae = (function() {
  if ((!this.ayz)) {
    this.ayy = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002433.$c_Lpresto_AgentView$$anon$33(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002434.$c_Lpresto_AgentView$$anon$34(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002435.$c_Lpresto_AgentView$$anon$35(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002436.$c_Lpresto_AgentView$$anon$36(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002437.$c_Lpresto_AgentView$$anon$37(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002439.$c_Lpresto_AgentView$$anon$39(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002441.$c_Lpresto_AgentView$$anon$41(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dAgent$002dView$0024$0024anon$002443.$c_Lpresto_AgentView$$anon$43(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))))))));
    this.ayz = true;
  }
  return this.ayy;
});
$p.w = (function() {
  if ((!this.ayE)) {
    this.ayD = true;
    this.ayE = true;
  }
  return this.ayD;
});
$p.cDX = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeSum__I__O__Lio_circe_JsonObject(this, new $j_presto$002e$002dAgent$002dView$0024$0024anon$002444.$c_Lpresto_AgentView$$anon$44().cME(a), a);
});
$p.ac = (function(a) {
  return this.cDX(a);
});
var $d_Lpresto_AgentView$$anon$32 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$32, "presto.AgentView$$anon$32", ({
  DX: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$32 as $d_Lpresto_AgentView$$anon$32 };
//# sourceMappingURL=presto.-Agent-View$$anon$32.js.map
